/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmLocTaxonomy_CmLocTaxonomyImpl_Fragment, CmLocTaxonomy_SosLocationImpl_Fragment } from './CMLocTaxonomy.fragment';
import { gql } from '@apollo/client';
import { CmLocTaxonomyFragmentDoc } from './CMLocTaxonomy.fragment';
export type SosLocationFragment = (
  { __typename?: 'SOSLocationImpl', name: string, federalstate?: string | null, address?: string | null, shortName?: string | null, key?: string | null, postcode?: string | null, latitudeLongitude?: string | null, cmLocationTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLocTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLocTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmLocTaxonomy_SosLocationImpl_Fragment
);

export const SosLocationFragmentDoc = gql`
    fragment SOSLocation on SOSLocation {
  ...CMLocTaxonomy
  name
  federalstate
  address
  shortName
  key
  cmLocationTaxonomy {
    ...CMLocTaxonomy
  }
  postcode
  latitudeLongitude
}
    ${CmLocTaxonomyFragmentDoc}`;